import "babel-polyfill";
import "./libs/slick"
import "./libs/jcf/jcf.js";
import "./libs/jcf/jcf.scrollable.js";
import "./libs/jcf/jcf.select.js";

import {binder} from "./libs/binder";
import {constants} from "./modules/module";
import {mobileNav} from "./modules/mobileNav";
import {stickyHeader} from "./modules/stickyHeader";
import {pageProgressBar} from "./modules/pageProgressBar";
import {relatedPostsSlider} from "./modules/relatedPostsSlider";
import {customSelect} from "./modules/customSelect";
import {map} from "./modules/map";
import {about} from "./modules/about";
import {mainSliderPhotos} from "./modules/mainSliderPhotos";
import {video} from "./modules/video";
import {stickySharing} from "./modules/stickySharing";
import {mobileFilterProperties} from "./modules/mobileFilterProperties";


binder({
    bounds: {
        "html": constants,
        ".header": [stickyHeader, mobileNav],
        "#page-progress-bar": pageProgressBar,
        ".related-posts-slider": relatedPostsSlider,
        "select": customSelect,
        ".map-section": map,
        "body.page-template-about": about,
        ".main-slider": mainSliderPhotos,
        ".video-section": video,
        ".holder-for-sticky": stickySharing,
        ".map-mobile": mobileFilterProperties
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js